module.exports = __webpack_public_path__ + "img/digitalOnnuriMain.a3171630.png";